import * as React from 'react';
import { useSelector } from 'react-redux';
import { BasicInfo } from '../../components/BasicInfo';
import { BuilderInfoItem } from '../../components/BasicInfo/parts/BuilderInfoItem';
import { MultipleBuildersInfo } from '../../components/BasicInfo/parts/MultipleBuildersInfo';
import { SimpleInfoItem } from '../../components/BasicInfo/parts/SimpleInfoItem';
import {
  getSpecialStatusDisplay,
  getUndergroundInfo,
  getNewbuildingClassName,
  getBuilder,
  getFirstRoadInfo,
  getBuilders,
} from '../../selectors/newbuilding';
import { trackTransferToDeveloperCard } from '../Builder/tracking';

export function BasicInfoContainer() {
  const specialStatus = useSelector(getSpecialStatusDisplay);
  const undergrounds = useSelector(getUndergroundInfo);
  const roadInfo = useSelector(getFirstRoadInfo);
  const className = useSelector(getNewbuildingClassName);
  const builder = useSelector(getBuilder);
  const builders = useSelector(getBuilders);

  const transportInfo = React.useMemo(() => {
    return undergrounds && undergrounds[0]
      ? { title: 'Метро', value: undergrounds[0].name }
      : roadInfo
        ? { title: 'Шоссе', value: `${roadInfo.name} шоссе ${roadInfo.distance} км от МКАД` }
        : null;
  }, [undergrounds, roadInfo]);

  return (
    <BasicInfo>
      <SimpleInfoItem title="Сдача" value={specialStatus} />
      {transportInfo && <SimpleInfoItem title={transportInfo.title} value={transportInfo.value} />}
      <SimpleInfoItem title="Класс" value={className} />
      {builders.length === 1 && (
        <BuilderInfoItem
          onClick={trackTransferToDeveloperCard}
          value={builder.name}
          logoUrl={builder.logoUrl}
          linkUrl={builder.profileUrl}
        />
      )}
      {builders.length > 1 && (
        <MultipleBuildersInfo builders={builders} onBuilderClick={trackTransferToDeveloperCard} />
      )}
    </BasicInfo>
  );
}
